import { logger } from "../utils/utils";
import api from "./apis/api";

class RumTypeService {
  createRumType(payload) {
    logger("RumTypeService", "createRumType");
    return api.rumType.createRumType(payload);
  }

  updateRumType(id, payload) {
    logger("RumTypeService", "updateRumType");
    return api.rumType.updateRumType(id, payload);
  }

  getRumTypeList(payload) {
    logger("RumTypeService", "getRumTypeList");
    return api.rumType.getRumTypeList(payload);
  }
  
  deleteRumType(id){
    logger("RumTypeService", "deleteRumType");
    return api.rumType.deleteRumType(id);
  }
}

export default new RumTypeService();
